import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Inspx from "inspx";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import { ReactElement } from "react";
import { DepartmentsProvider } from "./context/DepartmentsContext";
import { OriasAndSirenProvider } from "./context/oriasAndSirenContext.tsx";
import { REACT_QUERY_DEVTOOLS } from "./environment/environment.ts";

const queryClient = new QueryClient();

interface ProvidersProps {
	children: ReactElement;
}

export function Providers({ children }: ProvidersProps) {
	return (
		<QueryClientProvider client={queryClient}>
			<DepartmentsProvider>
				<OriasAndSirenProvider>
					<NuqsAdapter>
						<Inspx>{children}</Inspx>
					</NuqsAdapter>
				</OriasAndSirenProvider>
			</DepartmentsProvider>
			{REACT_QUERY_DEVTOOLS && <ReactQueryDevtools initialIsOpen={false} />}
		</QueryClientProvider>
	);
}
